import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Section, IconMessage, Heading } from '../s'
import Paragraph from 'components/typography/paragraph'
import { UnorderedList as Bullets, ListItem as Bullet } from 'components/typography/list'
import { AlertTriangleFilled as Warning } from 'components/feather'

const PowerOfficeValueMapping = () => (
    <>
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_poweroffice_heading_bank_account_handling"
                    defaultMessage="Bank account handling" />
            </Heading>
            <Bullets>
                <Bullet>
                    <FormattedMessage
                        id="integration_poweroffice_bank_account_handling_added_to_list_in_poweroffice"
                        defaultMessage="If a bank account is changed in Huma, it will be added to the list of bank accounts, and set as the salary account, for that employee in PowerOffice." />
                </Bullet>
                <Bullet>
                    <FormattedMessage
                        id="integration_poweroffice_bank_account_handling_deleting"
                        defaultMessage="If a bank account is deleted in Huma, the salary account for that employee will also be deleted in PowerOffice." />
                </Bullet>
                <Bullet>
                    <FormattedMessage
                        id="integration_poweroffice_bank_account_handling_old_bank_account"
                        defaultMessage="When an existing salary account in PowerOffice is deleted or replaced by a new account, the old bank account is kept in the list of bank accounts in PowerOffice, but set to inactive." />
                </Bullet>
                <Bullet>
                    <FormattedMessage
                        id="integration_poweroffice_bank_account_handling_changing_expenses_account"
                        defaultMessage="Before Huma makes a change to an employee's salary account in PowerOffice, we check if the same account is used for both salary and expenses (or if both are empty). If they are the same, we set both salary and expenses account to the new account. If they are different, we only set the salary account and leave the expenses account unchanged." />
                </Bullet>
            </Bullets>
        </Section>
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_poweroffice_heading_employment_id_handling"
                    defaultMessage="Employment ID handling" />
            </Heading>
            <IconMessage className="warning">
                <Warning size={20} />
                <Paragraph className="compact">
                    <FormattedMessage
                        id="integration_poweroffice_employment_id_handling"
                        defaultMessage="Since PowerOffice’s API uses employment ID to identify which employee to update, we tread extra carefully if this value is changed. If you change an employee’s Employment ID in Huma, we stop sending updates for that employee to PowerOffice, in order to be sure we don’t inadvertently overwrite data for the wrong person. We also do this if we find during an update that a connected employee’s email address or Employment ID has changed in PowerOffice. In both cases, the user can be reconnected for automatic updates by performing a manual synchronization, where you can verify that the user is being matched correctly." />
                </Paragraph>
            </IconMessage>
        </Section>
    </>
)

export default PowerOfficeValueMapping